import { render } from "./Universitas.vue?vue&type=template&id=a879e968"
import script from "./Universitas.vue?vue&type=script&lang=js"
export * from "./Universitas.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__